import React, { useEffect, useState } from "react";
import s from "./ConfirmStepper.module.css";

//Servicios
import providersService from "../../../../../../api/providers/providersService";
import { getAgencieById } from "../../../../../../api/agencies/AgenciesService";
//assets
import { dateFormats } from "../../../../../../helpers/convertDate";
import { formatJava } from "../../../../../../config/strings";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

//Material
import {
  CircularProgress,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { useDispatch } from "react-redux";
import useTranslationException from "../../../../../../helpers/exceptions";
import couponsService from "../../../../../../api/delivery/couponsService";
const ConfirmationStepper = ({ form, raffles }) => {
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const dates = dateFormats();

  const { textColor } = useSelector((state) => state.local);
  const gamesRedux = useSelector((state) => state.gamma.allGameOffersActive);

  const dispatch = useDispatch();

  const [deliveryEntity, setDeliveryEntity] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (form.supplierId) {
      providersService
        .getSupplierById(form.supplierId)
        .then((res) => {
          setDeliveryEntity(res);
        })
        .then(() => setLoading(false))
        .catch((e) => {
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
          setLoading(false);
        });
    } else {
      couponsService
        .getAgencyById(form.agencyId)
        .then((res) => setDeliveryEntity(res))
        .then(() => setLoading(false))
        .catch((e) => {
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
          setLoading(false);
        });
    }
  }, []);

  return (
    <Grid item container xs={12} className={s.container} sx={{ mb: 5 }}>
      <Grid item container xs={12} sx={{ mt: 2, alignItems: "flex-start" }}>
        <Grid item xs={6}>
          <h4 style={{ margin: 0, fontSize: "1.5rem", fontWeight: 400 }}>
            {t("deliveryNote")} N°{" "}
            {form.type === "Salida" ? form.nroOutput : form.nroInput}
          </h4>
          <p
            style={{
              margin: 0,
              marginTop: "5px",
              fontSize: "1.2rem",
              fontWeight: 300,
              opacity: 0.7,
            }}
          >
            {t("verifyAndConfirm")}
          </p>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "start",
          }}
        >
          <p
            style={{
              margin: 0,
              marginTop: "5px",
              fontSize: "1.3rem",
              fontWeight: 400,
            }}
          >
            {t("date")}:
          </p>
          <p
            style={{
              margin: 0,
              marginTop: "5px",
              marginLeft: "10px",
              fontSize: "1.3rem",
              fontWeight: 300,
            }}
          >
            {dates.formatLocalDate(form.date, formatJava)}
          </p>
        </Grid>
      </Grid>

      {loading ? (
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
          }}
        >
          <CircularProgress size="2rem" />
        </Grid>
      ) : (
        <>
          <Grid item container xs={12} className={s.init}>
            <Grid item xs={3} className={s.item}>
              <h4>{t("type")}</h4>
              <p>
                {form.type}{" "}
                {form.type === "Salida"
                  ? form.supplierId
                    ? `(${t("returnToProvider")})`
                    : `(${t("distribution")})`
                  : form.supplierId
                    ? `(${t("income")})`
                    : `(${t("return")})`}
              </p>
            </Grid>
            <Grid item xs={3} className={s.item}>
              <h4>{t("state")}</h4>
              <p>{form.state}</p>
            </Grid>
            <Grid item xs={3} className={s.item}>
              <h4>{t("shipperAddress")}</h4>
              <p>
                {form.type === "Salida"
                  ? form.lotteryName
                  : form.supplierId
                    ? `${form.supplierName}`
                    : `${form.agencyName}`}
              </p>
              <p className={s.address}>
                {form.type === "Salida"
                  ? ""
                  : form.supplierId
                    ? `${deliveryEntity?.address || ""} ${deliveryEntity?.numberAddress || ""}`
                    : `${deliveryEntity?.address?.street || ""} ${deliveryEntity?.address?.number || ""}`}
              </p>
            </Grid>
            <Grid item xs={3} className={s.item}>
              <h4>{t("destination")}</h4>
              <p>
                {form.type === "Entrada"
                  ? form.lotteryName
                  : form.supplierId
                    ? `${form.supplierName}`
                    : `${form.agencyName}`}
              </p>
              <p className={s.address}>
                {form.type === "Entrada"
                  ? ""
                  : form.supplierId
                    ? `${deliveryEntity?.address || ""} ${deliveryEntity?.numberAddress || ""}`
                    : `${deliveryEntity?.address?.street || ""} ${deliveryEntity?.address?.number || ""}`}
              </p>
            </Grid>
          </Grid>

          <Grid item xs={12} className={s.init}>
            <h4
              style={{
                fontSize: "1.2rem",
                fontWeight: "400",
                marginTop: "20px",
                marginBottom: "5px",
              }}
            >
              {t("observations")}
            </h4>
            <p
              style={{
                fontSize: "1.1rem",
                fontWeight: "300",
                margin: 0,
                marginTop: "5px",
              }}
            >
              {form.observations || "Sin observaciones"}
            </p>
          </Grid>

          <Grid item xs={12} className={s.init}>
            <h4
              style={{
                fontSize: "1.2rem",
                fontWeight: "400",
                marginTop: "20px",
                marginBottom: "5px",
              }}
            >
              {t("purchaseOrder")}
            </h4>
            <p
              style={{
                fontSize: "1.1rem",
                fontWeight: "300",
                margin: 0,
                marginTop: "5px",
              }}
            >
              {form.orderId || t("noPurchaseOrder")}
            </p>
          </Grid>

          <Grid item xs={12} sx={{ my: 3 }}>
            <h4
              style={{
                fontSize: "1.2rem",
                fontWeight: "400",
                marginTop: "5px",
                marginBottom: "15px",
              }}
            >
              {t("details")}
            </h4>
            <TableContainer className={s.tableContainer}>
              <Table>
                <TableHead sx={{ backgroundColor: "primary.main" }}>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("quantity")}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >{`${t("coupons")}`}</TableCell>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("game")}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("drawNumber")}/{t("serie")}
                  </TableCell>
                </TableHead>
                <TableBody>
                  {form.detailList.map((item, i) => (
                    <React.Fragment key={i}>
                      <TableRow>
                        <TableCell sx={{ fontSize: ".9rem" }}>
                          {item.amount}
                        </TableCell>
                        <TableCell sx={{ fontSize: ".9rem" }}>
                          {item.nroCouponFrom}-{item.nroCouponTo}
                        </TableCell>
                        <TableCell sx={{ fontSize: ".9rem" }}>
                          {gamesRedux?.find(
                            (i) => i.modality?.game?.id === item.gameId,
                          )
                            ? gamesRedux?.find(
                                (i) => i.modality?.game?.id === item.gameId,
                              ).modality.game.name
                            : "-"}
                        </TableCell>
                        <TableCell sx={{ fontSize: ".9rem" }}>
                          {raffles[i]?.raffleReadDTO?.number ||
                            raffles[i]?.raffleReadDTO?.serie ||
                            "-"}
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default ConfirmationStepper;
